import * as React from 'react';
import {useProgressAchievementsQuery} from "../../../../types.d";
import {Link} from "react-router-dom";

interface ProgressAchievementsProps {
    languageId: number;
    baseUrl: string;
}

export const ProgressAchievements = (props: ProgressAchievementsProps) => {
    const items = useProgressAchievementsQuery({
        fetchPolicy: 'network-only',
        variables: {
            language: Number(props.languageId)
        }
    });

    if (!items.data) {
        return null;
    }

    return <div>
        { items.data && items.data.progressAchievements.map(item => (
            <div className={'card mt-3'} key={item.id}>
                <div className={'card-body'}>
                    <div className="media">
                        <img src={item.image} width={100} className="align-self-center mr-3" />
                        <div className="media-body">
                            <h5 className="mt-0"><Link to={`${props.baseUrl}/modal/${item.id}`}>Position {item.position}</Link></h5>
                            { item.description }
                        </div>
                    </div>
                </div>
            </div>
        )) }

        <Link to={`${props.baseUrl}/modal/create`} className={'btn btn-primary mt-3'}>Add progress modal</Link>
    </div>
};
